<template>
    <div class="tevalis-configuration-step-two">
        <div class="header">
            <span>Tevalis configuration</span>
        </div>

        <div class="content">
            <div class="field__wrapper">
                <span class="d-block m-bottom-10">Site Location</span>
                <el-input v-model="form.companyId" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/colors.scss';
@import 'static/scss/fonts/fonts';
.tevalis-configuration-step-two {

    .header {
        @include alata-fonts(28px, 150%, 500, $white)
    }
}
</style>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/tevalisConfigurationStepTwo.vue